export enum ActionTypes {
  RESET_STORE = "RESET_STORE",
}
